import React, { useState, useEffect, useRef } from 'react';
import { FaPlay, FaInfoCircle, FaChevronLeft, FaChevronRight, FaTimes, FaSearch } from 'react-icons/fa';
import moviesData from '../data/moviesData';

const MovieSection = () => {
  const [movies, setMovies] = useState([]);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [selectedInfo, setSelectedInfo] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    // Simulating fetching data from a JSON file
    const fetchMovies = async () => {
      setMovies(moviesData.movies);
    };

    fetchMovies();
  }, []);

  const handleMovieSelect = (movie) => {
    setSelectedMovie(movie);
  };

  const handleInfoSelect = (movie) => {
    setSelectedInfo(movie);
  };

  const handleCloseVideo = () => {
    setSelectedMovie(null);
  };

  const handleCloseInfo = () => {
    setSelectedInfo(null);
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilter = (filter) => {
    setSelectedFilter(filter);
  };

  const filteredMovies = movies.filter((movie) => {
    const matchesSearch = movie.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = selectedFilter === 'all' || movie.genres.includes(selectedFilter);
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="bg-gray-900 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-extrabold text-white mb-8">Watch Full Movies</h2>
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-between">
          <div className="relative w-full sm:w-64 mb-4 sm:mb-0">
            <input
              type="text"
              placeholder="Search movies..."
              className="w-full bg-gray-800 text-white rounded-md py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={searchTerm}
              onChange={handleSearch}
            />
            <FaSearch className="absolute left-3 top-3 text-gray-400" />
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => handleFilter('all')}
              className={`px-3 py-1 rounded-md ${selectedFilter === 'all' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300'}`}
            >
              All
            </button>
            <button
              onClick={() => handleFilter('action')}
              className={`px-3 py-1 rounded-md ${selectedFilter === 'action' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300'}`}
            >
              Action
            </button>
            <button
              onClick={() => handleFilter('comedy')}
              className={`px-3 py-1 rounded-md ${selectedFilter === 'comedy' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300'}`}
            >
              Comedy
            </button>
            <button
              onClick={() => handleFilter('sci-fi')}
              className={`px-3 py-1 rounded-md ${selectedFilter === 'sci-fi' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300'}`}
            >
              Sci-Fi
            </button>
            <button
              onClick={() => handleFilter('drama')}
              className={`px-3 py-1 rounded-md ${selectedFilter === 'drama' ? 'bg-indigo-600 text-white' : 'bg-gray-700 text-gray-300'}`}
            >
              Drama
            </button>
          </div>
        </div>
        <div className="relative">
          <button
            onClick={scrollLeft}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full z-10"
          >
            <FaChevronLeft />
          </button>
          <div
            ref={scrollContainerRef}
            className="flex overflow-x-auto space-x-6 pb-4 scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {filteredMovies.map((movie, index) => (
              <div key={index} className="flex-none w-64 bg-gray-800 rounded-lg overflow-hidden shadow-lg">
                <img src={movie.thumbnail} alt={movie.title} className="w-full h-36 object-cover" />
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-white mb-2 truncate">{movie.title}</h3>
                  <p className="text-gray-400 text-sm mb-4 h-12 overflow-hidden">{movie.description}</p>
                  <div className="flex justify-between">
                    <button
                      onClick={() => handleMovieSelect(movie)}
                      className="flex items-center justify-center px-3 py-1 text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <FaPlay className="mr-1" /> Watch
                    </button>
                    <button 
                      onClick={() => handleInfoSelect(movie)}
                      className="flex items-center justify-center px-3 py-1 text-xs font-medium rounded-md text-indigo-600 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <FaInfoCircle className="mr-1" /> Info
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button
            onClick={scrollRight}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full z-10"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>

      {selectedMovie && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 h-3/4">
          <div className="bg-gray-900 p-4 rounded-lg max-w-3xl w-full h-full">
            <div className="aspect-w-16 aspect-h-9 mb-4 h-full">
              <iframe
                src={selectedMovie.youtubeLink}
                title={selectedMovie.title}
                className="w-full h-full"
                allowFullScreen
              ></iframe>
            </div>
            <div className="flex justify-end">
              <button
                onClick={handleCloseVideo}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedInfo && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-gray-900 p-6 rounded-lg max-w-lg w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-white">{selectedInfo.title}</h3>
              <button
                onClick={handleCloseInfo}
                className="text-gray-400 hover:text-white focus:outline-none"
              >
                <FaTimes size={24} />
              </button>
            </div>
            <img src={selectedInfo.thumbnail} alt={selectedInfo.title} className="w-full h-48 object-cover rounded-lg mb-4" />
            <p className="text-gray-300 mb-4">{selectedInfo.description}</p>
            <div className="mb-4">
              <h4 className="text-white font-semibold mb-2">Genres:</h4>
              <div className="flex flex-wrap gap-2">
                {selectedInfo.genres.map((genre, index) => (
                  <span key={index} className="px-2 py-1 bg-gray-700 text-gray-300 rounded-md text-sm">
                    {genre}
                  </span>
                ))}
              </div>
            </div>
            <button
              onClick={() => {
                handleCloseInfo();
                handleMovieSelect(selectedInfo);
              }}
              className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Watch Movie
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MovieSection;
